import type { TurnId, TurnKind } from './types';

/** Turn index → kind. Frozen by the #580 contract. */
export const TURN_KIND_BY_ID: Record<TurnId, TurnKind> = {
  1: 'adaptive_question',
  2: 'adaptive_followup',
  3: 'simulation_beat',
  4: 'timed_question',
  5: 'flashcard',
  6: 'ask_pam',
};

export function nextTurnId(current: TurnId): TurnId | null {
  return current < 6 ? ((current + 1) as TurnId) : null;
}
